import { parsePhoneNumberFromString } from 'libphonenumber-js/min';
import type { BuiltinAnswers } from './types';

export const PHONE_HELP = 'Include the area code, such as 512-555-0100. For an international number, start with + and the country code.';
export const PHONE_ERROR = 'Enter a valid phone number.';

function parse(value: string) {
  const text = value.trim();
  // Do not extract a plausible number from arbitrary text or silently drop an invalid suffix.
  if (text.length > 100 || !/^[+\d\s().-]+(?:\s*(?:ext\.?|x|#)\s*\d{1,8})?$/i.test(text)) return undefined;
  const phone = parsePhoneNumberFromString(text, { defaultCountry: 'US', extract: false });
  return phone?.isValid() ? phone : undefined;
}
export function isValidPhone(value: string): boolean { return !!parse(value); }

/** Leave incomplete input intact. Format completed numbers without losing country codes or extensions. */
export function formatPhone(value: string): string {
  const phone = parse(value);
  if (!phone) return value;
  const digits = String(phone.nationalNumber);
  const number = phone.countryCallingCode === '1'
    ? `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`
    : phone.formatInternational().replace(/ ext\. \d+$/, '');
  return number + (phone.ext ? ` ext. ${phone.ext}` : '');
}
export function formatBuiltinPhones(b: BuiltinAnswers): BuiltinAnswers {
  return { ...b, telephone: formatPhone(b.telephone), emergencyPrimaryPhone: formatPhone(b.emergencyPrimaryPhone), emergencySecondaryPhone: formatPhone(b.emergencySecondaryPhone) };
}
